import React from "react";
import { HardHat, Users, Briefcase, ArrowRight, CheckCircle2 } from "lucide-react";
import { services } from "../data/mock";

const iconMap = { HardHat, Users, Briefcase };

export default function Services() {
  return (
    <section id="services" className="relative py-24 lg:py-32 bg-gradient-to-b from-[#0a0a0c] to-[#08080a] overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full bg-[#F5D000]/5 blur-[120px] pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
        <div className="max-w-3xl mb-14 reveal">
          <div className="text-[11px] uppercase tracking-[0.3em] text-amber-accent mb-4">What We Do</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05]">
            Civil engineers in Birmingham <span className="text-amber-accent">since 1957.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {services.map((s, idx) => {
            const Icon = iconMap[s.icon];
            return (
              <div
                key={s.id}
                className="reveal relative p-8 rounded-2xl bg-[#101014] border border-white/5 hover:border-[#F5D000]/40 transition-all duration-500 group"
                style={{ transitionDelay: `${idx * 100}ms` }}
              >
                <div className="absolute -top-6 left-8 w-14 h-14 rounded-xl bg-[#F5D000] flex items-center justify-center shadow-lg shadow-[#F5D000]/30 group-hover:rotate-[-8deg] transition-transform duration-500">
                  <Icon className="w-6 h-6 text-black" strokeWidth={2.2} />
                </div>
                <div className="mt-8">
                  <div className="text-5xl font-display font-bold text-white/5 group-hover:text-[#F5D000]/15 transition-colors mb-2">
                    0{s.id}
                  </div>
                  <h3 className="font-display text-2xl font-bold mb-3 text-white">{s.title}</h3>
                  <p className="text-sm text-white/65 leading-relaxed mb-6">{s.description}</p>
                  <ul className="space-y-2 mb-6">
                    {s.bullets.map((b) => (
                      <li key={b} className="flex items-center gap-2 text-sm text-white/75">
                        <CheckCircle2 className="w-4 h-4 text-[#F5D000] flex-shrink-0" />
                        {b}
                      </li>
                    ))}
                  </ul>
                  <a href="#contact" className="inline-flex items-center gap-1.5 text-sm font-semibold text-white group/link">
                    <span className="link-shimmer">Learn more</span>
                    <ArrowRight className="w-4 h-4 transition-transform group-hover/link:translate-x-1" />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
